<template>
  <b-container>
      <!-- {{moduleId}} -->
    <draft :formId="id" :moduleId="moduleId"></draft>
  </b-container>
</template>
<script>
export default {
  name: "ModuleFormDraft",
  props: {
    id: String,
    moduleId: String
  },
  components: {
    Draft: () => import("@/pagesRms/checklist/form/Draft.vue"),
  },
};
</script>
